"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var types_1 = require("@/Types/types");
var MediaLibraryEditableName = function (_a) {
    var id = _a.id, name = _a.name, permissions = _a.permissions, viewMode = _a.viewMode, onSave = _a.onSave, onChange = _a.onChange, style = _a.style, folderPermissions = _a.folderPermissions;
    var _b = (0, react_1.useState)(name), itemName = _b[0], setItemName = _b[1];
    var _c = (0, react_1.useState)(name), lastValidName = _c[0], setLastValidName = _c[1];
    var inputRef = (0, react_1.useRef)(null);
    var inputTitleStyles = {
        outline: "none",
        border: "none",
        paddingTop: 2
    };
    var toggleEditState = function (editState) {
        if (!editState) {
            saveNameHandler();
        }
    };
    var saveNameHandler = function () {
        var trimmedName = itemName.trim();
        if (trimmedName && trimmedName !== lastValidName) {
            onSave === null || onSave === void 0 ? void 0 : onSave(id, trimmedName);
            setLastValidName(trimmedName);
        }
        else {
            setItemName(lastValidName);
        }
    };
    var handleInputChange = function (event) {
        setItemName(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
    };
    var handleFocus = function () {
        toggleEditState(true);
    };
    var handleBlur = function () {
        toggleEditState(false);
    };
    var handleClick = function (event) {
        event.stopPropagation();
        if (inputRef.current) {
            inputRef.current.select();
        }
    };
    return (react_1.default.createElement("div", { className: "d-flex align-items-center w-100 ".concat(viewMode === "grid" ? "justify-content-center" : "") }, folderPermissions && folderPermissions.length > 0 ? (react_1.default.createElement(AccessControl_1.default, { resourceId: id, folderPermissions: folderPermissions, resourceType: types_1.ResourceType.FOLDER, conditionalChildren: [
            {
                permission: permissions.manage,
                children: (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("input", { ref: inputRef, className: "".concat(MediaLibrary_module_css_1.default["editable-name-header"], " border-top-0 border-start-0 border-end-0"), style: __assign(__assign({}, inputTitleStyles), style), value: itemName, type: "text", onFocus: handleFocus, onBlur: handleBlur, onChange: handleInputChange, onClick: handleClick, "data-cy": "editableGroupNameInput" }),
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPen, color: "var(--primary-color)", style: { fontSize: "10px", marginLeft: "5px", marginTop: "-2px" } })))
            },
            {
                permission: __spreadArray(__spreadArray([], permissions.read, true), permissions.write, true),
                children: (react_1.default.createElement("span", { style: __assign(__assign({ fontSize: "13px", textAlign: "center" }, style), inputTitleStyles), "data-cy": "editableGroupNameInput" }, itemName))
            }
        ] })) : (react_1.default.createElement("span", { style: __assign(__assign({ fontSize: "13px", textAlign: "center" }, style), inputTitleStyles), "data-cy": "editableGroupNameInput" }, itemName))));
};
exports.default = MediaLibraryEditableName;
